/* eslint-disable no-unused-vars */

import appConfig from "../../../../app-config";
import ApiService from "../../api.service";


ApiService.init(appConfig.VUE_APP_ROOT_API);

const LogInService = {
  async getInitialData() {
    const requestScreenData = {
      url: "api/InitialData"
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { LogInService };
